import * as ReactGA from 'react-ga';
import { Location } from 'history';

import { AppSettings } from './appSettings';
import {
    LOGOUT_SUCCESS,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
} from "../actions/login.actions";
import { GET_FORUM_SUCCESS } from "../actions/forum.actions";


export const trackPageView = (location: Location): void => {
    ReactGA.set({
        page: location.pathname
    });
    ReactGA.pageview(location.pathname);
};

export const initGa = (): void => {
    const debug: boolean = !AppSettings.productionMode;

    ReactGA.initialize(AppSettings.googleAnalyticsId, {
        debug
    });

    if (debug) {
        ReactGA.set({
            sendHitTask: null
        });
    }
};

// the discussion board doesn't use the router, so we track it manually based on redux actions
// this won't be necessary if the board is converted to use routing properly
export const discussionBoardAnalytics = store => next => action => {
    let state = store.getState();

    let currentUserId = state.currentUser ? Number(state.currentUser.userId) : -1;

    if (currentUserId != undefined) {
        ReactGA.set({ userId: currentUserId });
    }

    switch (action.type) {
        case GET_FORUM_SUCCESS:
            if (action.forum) {
                var value = Number(action.forum.id);
                var newPath = `/Board/${action.forum.title.replace(' ', '')}`;
                ReactGA.pageview(newPath);
                if (value != undefined) {
                    ReactGA.event({ category: "Navigate", action: newPath, value: value, label: newPath });
                }
            }
            break;
        case LOGOUT_SUCCESS:
            currentUserId = action.userId;
            ReactGA.event({ category: "Action", action: action.type, value: Number(currentUserId), label: "User" });
            break;
        case LOGIN_FAILURE:
            ReactGA.event({ category: "Action", action: action.type, value: Number(currentUserId), label: "User" });
            break;
        case LOGIN_SUCCESS:
            currentUserId = action.userId;
            ReactGA.event({ category: "Action", action: action.type, value: Number(currentUserId), label: "User" });
            break;
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/helpers/analytics.ts